export const inputStyles = {
	minH: "32px",
	h: "20px",
	p: "6px",
	fontSize: "13px",
	borderRadius: "none",
	textAlign: "center",
	borderColor: "gray.400",
	m: 0,
	"&:focus,&:hover": {
		boxShadow: "none",
		borderColor: "gray.400",
	},
};

export const reactColorfulStyles = {
	".react-colorful": {
		w: "254px",
		gap: "16px",
	},
	".react-colorful__saturation": {
		borderRadius: "none",
	},
	".react-colorful__alpha, .react-colorful__hue": {
		h: "8px",
		borderRadius: "8px",
	},
	".react-colorful__pointer": {
		h: "14px",
		w: "14px",
	},
	".react-colorful__alpha, .react-colorful__alpha-pointer": {
		bgSize: "3%",
	},
	".chakra-select": {
		background: "none",
		border: "0",
		fontSize: "13px",
		color: "black",
		h: "23px",
		p: "0",
		"&:focus": {
			boxShadow: "none",
			color: "black",
		},
		"&:hover": {
			color: "black",
		},
	},
};
